import {
  FETCH_TRANSLATIONS,
  UPDATE_TRANSLATION,
  DELETE_TRANSLATION,
  LOADING_TRANSLATIONS,
  SET_TRANSLATION_DICTIONARY,
  CLEAN_AUTH
} from "../actions/type";

const INIT_STATE = {
  translationMap: {}, // Map of translation ID to translation object
  dictionary: {}, // Optimized dictionary for lookups { word: { pos, translation/translations } }
  total: 0,
  page: 1,
  limit: 100,
  totalPages: 0,
  isLoading: false
};

export default (state = INIT_STATE, { type, payload }) => {
  switch (type) {
    case FETCH_TRANSLATIONS:
      return {
        ...state,
        // Replace if page 1 (new search/initial load), otherwise merge for pagination
        translationMap: payload.page === 1
          ? payload.translationMap
          : {
              ...state.translationMap,
              ...payload.translationMap
            },
        total: payload.total,
        page: payload.page,
        limit: payload.limit,
        totalPages: payload.totalPages
      };

    case UPDATE_TRANSLATION:
      return {
        ...state,
        translationMap: {
          ...state.translationMap,
          [payload.translation.id]: payload.translation
        }
      };

    case DELETE_TRANSLATION:
      const { [payload.word]: deleted, ...remainingTranslations } =
        state.translationMap;
      return {
        ...state,
        translationMap: remainingTranslations,
        total: state.total - 1
      };

    case SET_TRANSLATION_DICTIONARY:
      return {
        ...state,
        dictionary: payload.dictionary
      };

    case LOADING_TRANSLATIONS:
      return {
        ...state,
        isLoading: payload
      };

    case CLEAN_AUTH:
      return { ...INIT_STATE };

    default:
      return state;
  }
};
